import { ButtonIcon, Tooltip } from 'canoe';
import React from 'react';
import { useSlate, ReactEditor } from 'slate-react';

import { TooltipBodyWithShortcuts } from 'craft/components/TooltipBodyWithShortcuts';
import { isMarkActive, toggleMark } from 'craft/rte';

interface FormatButtonProps {
  format: string;
  tooltip: string;
  shortcuts: string[];
  icon: any;
  disabled?: boolean;
}

export const FormatButton = ({ format, icon, tooltip, shortcuts, disabled }: FormatButtonProps) => {
  const rteEditor = useSlate() as ReactEditor;
  const isActive = isMarkActive(rteEditor, format);

  const FormatIcon = icon;
  return (
    <Tooltip
      placement="top"
      offset="xxs"
      content={<TooltipBodyWithShortcuts content={tooltip} shortcuts={shortcuts} />}
    >
      <ButtonIcon
        disabled={disabled}
        size="small"
        icon={FormatIcon}
        active={isActive}
        onMouseDown={(e: React.MouseEvent) => {
          e.stopPropagation();
          e.preventDefault();
          toggleMark(rteEditor, format);
        }}
        radius="small"
        color="white"
      />
    </Tooltip>
  );
};
